<template>
  <form
    action="http://19.87.8.180:32790/image"
    method="post"
    enctype="multipart/form-data"
    target="_blank"
  >
    <input type="file" name="file" />
    <input type="submit" value="upload" />
  </form>
</template>
<script>
export default {
  name: 'test',
}
</script>